import { type FunctionalComponent, h } from '@stencil/core';
import type { GuidedNoResult } from '../api';
import folder_magnifying_glass from '../../../assets/svg/folder_magnifying_glass.svg';

interface IGuidedNoResults {
  enabled: boolean;
  data: Array<GuidedNoResult>;
}

export const GuidedNoResults: FunctionalComponent<IGuidedNoResults> = (props) => {
    const { enabled, data } = props;
    if (!enabled || data.length === 0) return null;
    const noResultsData = data[0];

    return (
      <div class="guided-pane__no-results-item">
        {noResultsData?.quartzIcon ? (
          <span innerHTML={folder_magnifying_glass}></span>
        ) : (
          ''
        )}
        <div
          class="guided-pane__no-results-text"
          innerHTML={noResultsData.markup}
        >
        </div>
        <div class="guided-pane__no-results-text">{noResultsData.text}</div>
      </div>
    );
};
